import { combineReducers } from 'redux';

import byId from './byId';

/**
 * @typedef {{
 *   byId: import('./byId').State
 * }} DealerConfigurationGeneralByIdReducer
 *
 */

export default combineReducers({
  byId,
});
